import CookiesContent from "../PrivacyAssests/Cookies.js";
import MetaTags from "../components/SEO/MetaTags";
import { pageConfigs } from "../utils/seo";

const CookiePolicy = () => {
    return (
        <>
            <MetaTags
                title={pageConfigs.cookiePolicy.title}
                description={pageConfigs.cookiePolicy.description}
                keywords={pageConfigs.cookiePolicy.keywords}
                canonical={pageConfigs.cookiePolicy.canonical}
                noindex={pageConfigs.cookiePolicy.noindex}
            />
            <div className="bg-gray-100 min-h-screen p-5 flex justify-center">
            <div className="bg-gray-900 shadow-lg rounded-lg p-6 w-full max-w-5xl lg:max-w-6xl xl:max-w-7xl">
                <h1 className="text-white text-3xl font-bold mb-6 text-center">COOKIE POLICY</h1>
                <div dangerouslySetInnerHTML={{ __html: CookiesContent }} />
            </div>
            </div>
        </>
    );
};

export default CookiePolicy;
